import { render, staticRenderFns } from "./Chapters.vue?vue&type=template&id=fc6786f0&"
import script from "./Chapters.vue?vue&type=script&lang=js&"
export * from "./Chapters.vue?vue&type=script&lang=js&"
import style0 from "./Chapters.vue?vue&type=style&index=0&id=fc6786f0&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports